import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";

export class DiscountControlTypeDto {
    idDiscountControlType?: number;
    description?: string;
    controlValueType?: string;
}

export class DiscountControlTypesResponse {
    DiscountControlTypesDto: DiscountControlTypeDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class DiscountControlTypesRequest {
    DiscountControlTypesDto: DiscountControlTypeDto = new DiscountControlTypeDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}